export const TABLE_HEADERS = [
  'users.table.header.name',
  'users.table.header.phone',
  'users.table.header.email',
  'users.table.header.schoolId',
  'users.table.header.role',
  'users.table.header.bus',
  'users.table.header.actions',
];

export const USER_ROLES = {
  ADMIN: 'administrator',
  CTM: 'crisis_team_member',
  DRIVER: 'driver',
  PARENT: 'parent',
  TM: 'transportation_manager',
  STAFF: 'staff',
  STUDENT: 'pupil',
  COMMUNICATION: 'communication_manager',
  SECURITY: 'security_manager',
  SUPERVISOR: 'supervisor',
};

export const USER_ROLES_FILTERS = {
  ALL: {
    // ALL - must go first
    LABEL: 'role.allRoles',
    VALUE: 'all',
  },
  ADMIN: {
    LABEL: 'role.administrator',
    VALUE: 'administrator',
  },
  CTM: {
    LABEL: 'role.crisis_team_member',
    VALUE: 'crisis_team_member',
  },
  DRIVER: {
    LABEL: 'role.driver',
    VALUE: 'driver',
  },
  PARENT: {
    LABEL: 'role.parent',
    VALUE: 'parent',
  },
  TM: {
    LABEL: 'role.transportation_manager',
    VALUE: 'transportation_manager',
  },
  STAFF: {
    LABEL: 'role.staff',
    VALUE: 'staff',
  },
  STUDENTS: {
    LABEL: 'role.student',
    VALUE: 'pupil',
  },
  COMMUNICATION: {
    LABEL: 'role.communication_manager',
    VALUE: 'communication_manager',
  },
  SECURITY: {
    LABEL: 'role.security_manager',
    VALUE: 'security_manager',
  },
  SUPERVISOR: {
    LABEL: 'role.supervisor',
    VALUE: 'supervisor',
  },
  ECA_MANAGER: {
    LABEL: 'role.eca_manager',
    VALUE: 'eca_manager',
  },
  ECA_ACTIVITY_LEAD: {
    LABEL: 'role.eca_activity_lead',
    VALUE: 'eca_activity_lead',
  },
  ECA_TEAM_MEMBER: {
    LABEL: 'role.eca_team_member',
    VALUE: 'eca_team_member',
  },
};

export const USER_GROUPS = [
  {
    label: 'role.administrator',
    value: 'administrator',
  },

  {
    label: 'role.crisis_team_member',
    value: 'crisis_team_member',
  },

  {
    label: 'role.transportation_manager',
    value: 'transportation_manager',
  },

  {
    label: 'role.communication_manager',
    value: 'communication_manager',
  },
  {
    label: 'role.security_manager',
    value: 'security_manager',
  },
  {
    label: 'role.eca_manager',
    value: 'eca_manager',
  },
  {
    label: 'role.eca_activity_lead',
    value: 'eca_activity_lead',
  },
  {
    label: 'role.eca_team_member',
    value: 'eca_team_member',
  },
];

export const USER_STATUS_FILTER = {
  ALL: {
    // ALL - must go first
    LABEL: 'status.all',
    VALUE: 'ALL',
  },
  ACTIVE: {
    LABEL: 'status.active',
    VALUE: 'ACTIVE',
  },

  DEACTIVATED: {
    LABEL: 'status.deactivated',
    VALUE: 'DEACTIVATED',
  },
};

export const TYPES_ADDITIONALS = [
  {
    label: 'modal.additionalContact.relationship.grandparent',
    value: 'Grandparent',
  },
  {
    label: 'modal.additionalContact.relationship.grandfather',
    value: 'Grandfather',
  },
  {
    label: 'modal.additionalContact.relationship.grandmother',
    value: 'Grandmother',
  },
  {
    label: 'modal.additionalContact.relationship.sister',
    value: 'Sister',
  },
  {
    label: 'modal.additionalContact.relationship.brother',
    value: 'Brother',
  },
  {
    label: 'modal.additionalContact.relationship.auntie',
    value: 'Auntie',
  },
  {
    label: 'modal.additionalContact.relationship.uncle',
    value: 'Uncle',
  },
  {
    label: 'modal.additionalContact.relationship.otherFamily',
    value: 'Other Family',
  },
  {
    label: 'modal.additionalContact.relationship.relative',
    value: 'Relative',
  },
  {
    label: 'modal.additionalContact.relationship.partner',
    value: 'Partner',
  },
  {
    label: 'modal.additionalContact.relationship.cousin',
    value: 'Cousin',
  },
  {
    label: 'modal.additionalContact.relationship.emergency',
    value: 'Emergency',
  },
  {
    label: 'modal.additionalContact.relationship.auPair',
    value: 'Au pair',
  },
  {
    label: 'modal.additionalContact.relationship.nanny',
    value: 'Nanny',
  },
  {
    label: 'modal.additionalContact.relationship.childminder',
    value: 'Childminder',
  },
];

export const TYPES_PARENTS = ['Mother', 'Father', 'Stepmother', 'Stepfather', 'Guardian'];

export const ACTIVATION_ACTIONS = {
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
};

export const CREATE = 'create';

export const UPDATE = 'update';
